import { Component, OnInit } from '@angular/core';
import { IServiceList, IServicePost, ServicesPageService } from '../../services-page.service';

@Component({
  selector: 'app-service-email-marketing',
  templateUrl: './service-email-marketing.component.html',
  styleUrls: ['./service-email-marketing.component.css']
})
export class ServiceEmailMarketingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
  }
}
